<div *ngIf="show" class="alert-wrapper" [style.paddingBottom.px]="paddingBottom">
  <div class="alert" [ngClass]="{'confirm': type === AlertTypesEnum.Confirm,
      'info': type === AlertTypesEnum.Info,
      'error-info': type === AlertTypesEnum.ErrorInfo,
      'success': type === AlertTypesEnum.Success,
      'error': type === AlertTypesEnum.Error,
      'warning': type === AlertTypesEnum.Warning,
      'global': global,
      'pending-transaction-successfully-verified': type === AlertTypesEnum.PendingTransactionsSuccessfullyVerified}"
  >
    <div class="message-container"
         [style.maxWidth]="maxWidth"
         [ngClass]="{'text-full-width' : textFullWidth}"
    >
      <img class="alert-icon" *ngIf="type === AlertTypesEnum.Confirm"
           src="assets/icons/icon-alert-confirm.svg" alt="confirm"/>
      <img class="alert-icon" *ngIf="type === AlertTypesEnum.Info"
           src="assets/icons/icon-alert-info.svg" alt="info"/>
      <img class="alert-icon" *ngIf="type === AlertTypesEnum.ErrorInfo"
           src="assets/icons/icon-alert-error-info.svg" alt="info"/>
      <img class="alert-icon" *ngIf="type === AlertTypesEnum.Success"
           src="assets/icons/icon-alert-success.svg" alt="success"/>
      <img class="alert-icon" *ngIf="type === AlertTypesEnum.Error"
           src="assets/icons/icon-alert-error.svg" alt="error"/>
      <img class="alert-icon icon-start" *ngIf="type === AlertTypesEnum.Warning"
           src="assets/icons/icon-alert-exclamation-triangle-fill.svg" alt="warning"/>
      <img class="alert-icon" *ngIf="type === AlertTypesEnum.PendingTransactionsSuccessfullyVerified"
           src="assets/icons/icon-check-mark-transparent.svg" alt="warning"/>

      <div #childContent>
        <ng-content></ng-content>
      </div>
      <div *ngIf="!childContent.children.length">
        <div class="message">
          {{message}}
        </div>
        <div *ngIf="description" class="description">
          {{description}}
        </div>
      </div>
    </div>

    <div class="animation-focus-default" (click)="closeAlert.emit()" *ngIf="!hasCustomCloseButton && !hideCloseButton">
     <ng-container *ngIf="!closeButtonName; else customCloseButton">
          <img *ngIf="type === AlertTypesEnum.Confirm || type === AlertTypesEnum.Info"
               class="close-icon" src="assets/icons/icon-close-blue.svg" alt="close" />
          <img *ngIf="type === AlertTypesEnum.Success"
               class="close-icon" src="assets/icons/icon-close-green.svg" alt="close" />
          <img *ngIf="type === AlertTypesEnum.Error || type === AlertTypesEnum.ErrorInfo"
               class="close-icon" src="assets/icons/icon-close-red.svg" alt="close" />
     </ng-container>
     <ng-template #customCloseButton>
          <img class="close-icon" [src]="'assets/icons/icon-' + closeButtonName + '.svg'" alt="close" />
     </ng-template>
    </div>
     <div class="flex flex-row" *ngIf="hasContent || hasCustomCloseButton">
          <ng-content select="[contentSelect='besideDefaultControls']"></ng-content>
          <button *ngIf="hasCustomCloseButton && !hideCloseButton" (click)="closeOnButton.emit()"
               class="close-btn animation-focus-default" [class.large]="largeButton">
               <img *ngIf="useButtonImage" class="close-btn-icon" src="assets/icons/icon-thumb-up.svg"
                    alt="close-btn-icon" />
               {{buttonText}}
          </button>
          <button *ngIf="hasSecondCustomCloseButton && !hideCloseButton" (click)="secondCloseButtonClicked.emit()"
               class="close-btn animation-focus-default" [class.large]="largeButton">
               {{secondCustomCloseButtonText}}
          </button>
     </div>
  </div>
</div>
